{
  "A1": "A1",
  "A2": "A2",
  "accents_and_special_characters": "Acentos e caracteres especiais",
  "account": "Account",
  "activity": "Atividade",
  "actor": "Ator {{number}}",
  "actor_2": "Ator 2",
  "actor_name": "nome do ator",
  "actor_voice": "voz do ator",
  "add_alternatives": "Adicionar alternativas",
  "add_another_reply": "Adicionar outra resposta",
  "add_courses": "Adicionar cursos",
  "add_answer": "Adicionar resposta",
  "add_image": "Adicionar imagem",
  "add_image_desc": "Adicione uma imagem ao seu exercício!",
  "add_link": "Adicionar Link",
  "add_link_desc": "Adicione um link ao seu exercício!",
  "all_steps_complete": "Todos os passos concluídos",
  "alternative_versions": "Versões alternativas",
  "archive_recording_error": "Ocorreu um problema ao arquivar a gravação",
  "assign": "Atribuir",
  "attach_file": "Anexar ficheiro",
  "bot_not_found": "Chatbot não encontrado",
  "bot_not_found_desc": "Não conseguimos encontrar este chatbot. Pode ter sido eliminado ou tornado privado.",
  "categories": "Categorias",
  "chart": "Gráfico",
  "choose_length_of_roleplay": "Escolha a duração do cenário",
  "clear": "Limpar",
  "close_pdf": "Fechar PDF",
  "comma_seperated_domains": "Domínios separados por vírgulas",
  "community": "Comunidade",
  "datetime": "Data e hora",
  "days": "dias",
  "days_late": "{{count}} dias de atraso",
  "discussion": "Discussão",
  "download_error": "Ocorreu um problema ao transferir o ficheiro",
  "editor_mode": "Modo de edição",
  "email_notifications": "Notificações por email",
  "enter_linguistic_goal": "Digite seu objetivo linguístico",
  "add_new": "Adicionar novo",
  "add_phrase": "Adicionar frase",
  "add_phrase_desc": "Adicione uma nova frase no idioma {{language}} para as pessoas aprenderem",
  "add_phrases": "Adicionar frases",
  "add_phrases_to_enable_exercise": "Adicione frases para permitir o exercício",
  "add_question": "Adicionar pergunta",
  "add_question_desc": "Faça uma pergunta de compreensão. A pergunta pode ter várias respostas corretas.",
  "add_review": "Adicione uma avaliação",
  "add_review_desc": "Compartilhe seus pensamentos abaixo",
  "add_script": "Adicionar Script",
  "add_section": "Adicionar seção",
  "add_substitution": "Adicionar substituição",
  "add_substitution_desc": "Com as substituições, você pode ver que 'o que' é expandido para 'o que é' - permitindo um melhor controle sobre como você responde à mensagem do usuário!",
  "add_topic": "Adicionar tópico",
  "add_topic_desc": "Os tópicos são agrupamentos lógicos de gatilhos. Quando um usuário está em um tópico, ele pode corresponder apenas a gatilhos que pertencem a esse tópico.",
  "add_topic_to_section": "Adicionar tópico à seção {{sectionId}}",
  "add_trigger": "Adicionar gatilho",
  "add_trigger_desc": "Um gatilho é uma linha de texto usada para corresponder à mensagem do usuário.",
  "add_variable": "Add variable",
  "add_variable_desc": "Variáveis de chatbot são informações que descrevem seu chatbot. Com variáveis de chatbot, podemos escrever respostas nas quais o chatbot pode contar um pouco sobre o usuário.",
  "add_voice": "Adicionar voz",
  "all": "Tudo",
  "all_topics_completed": "Todos os tópicos concluídos",
  "alternatives": "Alternativas",
  "alternatives_desc": "Uma lista de palavras ou frases que podem ser reutilizadas no seu chatbot.",
  "alternatives_name": "Name",
  "alternatives_value": "Lista de palavras (separadas por vírgula)",
  "answer": "Responda",
  "new_answer_placeholder": "Digite sua resposta aqui",
  "answer_message_100": "Perfeito, ótimo trabalho",
  "answer_message_90": "Você está chegando lá, continue tentando",
  "answer_message_95": "Essa foi por pouco, você está quase lá",
  "answer_message_wrong": "Isso não estava certo",
  "attempt": "Tentativa",
  "attempt_messages": "Tentativa de Exercício",
  "attempt_table": "Tentativas",
  "auto_translate": "Tradução automática",
  "auto_translate_phrase": "Frase de tradução automática",
  "avg_pronunciation_score": "Avg Pronunciation Score",
  "average_pronunciation_score_tooltip": "Average pronunciation score is",
  "B1": "B1",
  "B2": "B2 ",
  "back": "De volta",
  "back_to_course": "De volta ao curso",
  "blog": "Blog",
  "bot": "Chatbot",
  "bot-listen-and-speak": "Chatbot - Ouvir e Falar",
  "all_modes": "Todos os modos",
  "bot_information": "Informações sobre Chatbot",
  "bot_intro_message": "Mensagem de introdução ao chatbot",
  "bot_intro_message_helper_text": "Deixe em branco se desejar que o aluno inicie a conversa.",
  "bot_name": "Nome do chatbot",
  "bot_reply": "Resposta do chatbot",
  "bot_settings": "Configurações de chatbot",
  "bot_title": "Título do chatbot",
  "bot_voice": "Voz de chatbot",
  "bots": "Robôs de bate-papo",
  "bots_not_found_desc": "Crie o primeiro robô de bate-papo hoje",
  "bots_not_found_title": "Nenhum robô de bate-papo encontrado",
  "C1": "C1",
  "C2": "C2",
  "cancel": "Cancelar",
  "card_A1": "A1",
  "card_A2": "A2",
  "card_B1": "B1",
  "card_B2": "B2",
  "card_C1": "C1",
  "card_C2": "C2",
  "change_app_colors": "Alterar cores do aplicativo",
  "change_language": "Mudar língua",
  "chatbot_exercise_desc": "Converse com um chatbot para simular uma conversa sobre um tópico",
  "chatbots": "Robôs de bate-papo",
  "choose_avatar": "Escolha Nuala",
  "choose_from_file": "Escolha a partir do arquivo",
  "classroom_code": "Código da sala de aula",
  "classroom_code_label": "Digite o código da sala de aula",
  "classroom_code_not_valid": "Código da sala de aula inválido",
  "classroom_created": "Sala de aula criada",
  "classroom_deleted": "Sala de aula excluída",
  "classroom_information": "Informações da sala de aula",
  "classroom_name": "Nome da sala de aula",
  "classroom_not_found": "Sala de aula não encontrada",
  "classroom_not_found_desc": "Esta sala de aula pode ter sido excluída",
  "classroom_load_error": "Não foi possível carregar a sala de aula",
  "classroom_load_error_desc": "Ocorreu um erro ao carregar esta sala de aula. Tente novamente.",
  "classroom_settings": "Configurações da sala de aula",
  "classrooms": "Salas de aula",
  "classrooms_not_found_desc": "Crie a primeira sala de aula hoje",
  "classrooms_not_found_title": "Nenhuma sala de aula encontrada",
  "collaborators": "Contribuidores",
  "color": "Cor",
  "community_templates": "Comunidade Modelos",
  "completed": "Concluído",
  "completed_icon": "Ícone concluído",
  "completion": "Conclusão",
  "completions": "Conclusões",
  "confirmation": "Confirmação",
  "contact_form": "Formulário de Contato",
  "continue": "Continuar",
  "continue_exercise": "Continuar o exercício",
  "continue_learning": "Continue aprendendo",
  "continue_teaching": "Continue Ensinando",
  "copied": "Copiado",
  "copy_to_clipboard": "Copiar para área de transferência",
  "correct": "Certo",
  "correct_answer": "Resposta correta",
  "correct_answer_percentage": "Correct Answer Percentage",
  "course": "Curso",
  "course_code": "Código do curso",
  "course_code_label": "Digite o código do curso",
  "course_code_not_valid": "Código do curso inválido",
  "course_created": "Curso criado",
  "course_deleted": "Curso excluído",
  "course_information": "Informação do curso",
  "course_name": "Nome do curso",
  "course_not_found": "Curso não encontrado",
  "course_not_found_desc": "Este curso pode ter sido excluído",
  "course_outline": "Esboço de Curso",
  "course_progress": "Progresso do Curso",
  "course_settings": "Configurações do curso",
  "courses": "Cursos",
  "courses_not_found_desc": "Crie o primeiro curso hoje",
  "courses_not_found_title": "Nenhum curso encontrado",
  "create": "Criar",
  "create_bot": "Criar chatbot",
  "create_classroom": "Criar sala de aula",
  "create_course": "Criar curso",
  "create_course_section": "Criar seção do curso",
  "create_course_section_desc": "Cabe a você estruturar o curso. As estruturas de exemplo são 'Iniciante, Intermediário, Avançado' ou 'Semana 1, Semana 2, Semana 3'",
  "create_topic": "Criar tópico",
  "created_courses": "Cursos criados",
  "creation_visibility": "O conteúdo público pode ser usado como ponto de partida para outras criações de educadores.",
  "creator": "Criador",
  "customization": "Costumização",
  "dark_theme": "Tema escuro",
  "dark_theme_desc": "Torna as superfícies claras da página escuras, criando uma experiência ideal para a noite.",
  "delete_bot": "Excluir chatbot",
  "delete_bot_confirmation": "Tem certeza de que deseja excluir este chatbot?",
  "delete_classroom": "Excluir sala de aula",
  "delete_classroom_confirmation": "Tem certeza de que deseja excluir esta sala de aula?",
  "delete_course": "Excluir curso",
  "delete_course_confirmation": "Tem certeza de que deseja excluir este curso?",
  "delete_phrase": "Excluir frase",
  "delete_phrase_confirmation": "Tem certeza de que deseja excluir esta frase",
  "delete_review": "Excluir comentário",
  "delete_review_confirmation": "Tem certeza de que deseja excluir seu comentário?",
  "delete_roleplay": "Excluir função",
  "delete_roleplay_confirmation": "Tem certeza de que deseja excluir esta interpretação?",
  "delete_section": "Excluir seção",
  "delete_section_confirmation": "Tem certeza de que deseja excluir esta seção?",
  "delete_topic": "Excluir tópico",
  "delete_topic_confirmation": "Tem certeza de que deseja excluir este tópico?",
  "description": "Descrição",
  "difficulty": "dificuldade",
  "difficulties": "dificuldades",
  "disable": "Desativar",
  "disabled": "Desativado",
  "display": "Exibição",
  "display_classroom_code": "Display classroom code",
  "download_csv_file": "Baixar",
  "drop_csv_file_or_click_to_upload": "Solte o arquivo CSV ou clique para fazer o upload.",
  "edit": "Editar",
  "edit_bot": "Editar Chatbot",
  "edit_discussion": "Editar Discussão",
  "edit_roleplay": "Editar encenação",
  "email": "Email",
  "enable": "Ativar",
  "enabled": "Ativado",
  "enrolment_key": "Chave de inscrição",
  "enrolment_key_not_valid": "Chave de inscrição inválida",
  "enter_private_key": "Inserir chave privada",
  "error_generating_discussion": "Ocorreu um problema ao gerar a discussão",
  "exercise": "Exercício",
  "exercise_complete": "Exercício Completo",
  "exercise_completed_icon": "{{name}} concluído {{counter}} vez",
  "exercise_completion": "completou o exercício de {{exercise}} '{{id}}'",
  "exercise_in_progress": "começou o exercício de {{exercise}} '{{id}}'",
  "exercise_progress_bar": "Exercise progress bar",
  "exercise_info": "Informação do exercício",
  "exercise_no_longer_available": "Este exercício não está mais disponível",
  "exercises": "Exercícios",
  "exercises_completed": "Exercícios concluídos",
  "exercises_completed_icon": "{{name}} concluído {{counter}} vezes",
  "exit": "Sair",
  "expand": "Expandir",
  "fill_in_contact_form": "Preencha o formulário abaixo",
  "find_bot": "Achar um chatbot",
  "find_classroom": "Localizar sala de aula",
  "find_course": "Encontrar curso",
  "find_roleplay": "Encontrar dramatização",
  "finish": "Terminar",
  "finish_exercise": "Terminar Exercício",
  "for_lang": "Eu falo",
  "formatting_options": "Opções de formatação",
  "from": "De",
  "fullscreen": "Ecrã inteiro",
  "generate_definitions_info": "Gere definições para as frases desta lista.",
  "generating": "A gerar",
  "get_started": "Iniciar",
  "go_back": "Volte",
  "go_back_to_topic": "Voltar ao Tópico",
  "go_to": "Go to",
  "go_to_settings": "Ir para as definições",
  "group_information_form_title": "Fale-nos sobre o seu grupo",
  "group_member_limit": "Limite de membros do grupo",
  "group_name": "Nome do grupo",
  "group_picture": "Imagem do grupo",
  "group_subscription_form_title": "Configure a subscrição do grupo",
  "help": "Ajuda",
  "hidden": "Oculto",
  "hide": "Ocultar",
  "hide_bot": "Esconder chatbot",
  "hide_chatbots_exercise": "Esconder robôs de Bate-papo",
  "hide_listening_exercise": "Ocultar exercício auditivo",
  "hide_menu": "Esconder Menu",
  "hide_options": "Esconder opções",
  "hide_pronunciation_exercise": "Ocultar exercício de pronúncia",
  "hide_roleplay": "Ocultar encenação",
  "hide_roleplays_exercise": "Ocultar encenação",
  "hide_section": "Ocultar seção",
  "hide_topic": "Ocultar tópico",
  "hide_translation_exercise": "Ocultar exercício de tradução",
  "hide_word_bank": "Esconder Banco de Palavras",
  "home": "Home",
  "how_to_join_find_button": "Procure o botão {{button}} e clique nele.",
  "how_to_join_get_ready": "Prepare-se para jogar.",
  "how_to_join_intro": "Para entrar no jogo, siga estes passos:",
  "how_to_join_open_classroom": "Abra a turma {{classroom}} ou digitalize o código QR abaixo",
  "how_to_join_sign_in": "Inicie sessão na sua conta.",
  "how_to_join_title": "Como entrar no jogo",
  "in_game": "No jogo",
  "in_progress": "Continue jogando",
  "incorrect": "Incorreto",
  "insert_bold": "Inserir negrito",
  "insert_italic": "Inserir itálico",
  "insert_link": "Inserir link",
  "insert_photo": "Inserir foto",
  "instruction_message": "Instruções",
  "join": "Junte-se",
  "join_classroom": "Participar da sala de aula",
  "join_code_desc": "Os alunos podem usar o código abaixo para participar",
  "join_course": "Participar do curso",
  "join_date": "Data de Ingresso",
  "joined": "Ingressou",
  "joined_classroom": "Sala de aula ingressada",
  "joined_course": "Curso ingressado",
  "language": "Linguágem",
  "language_phrase": "frase {{language}} ",
  "language_translation": "tradução {{language}}",
  "learn": "Aprender",
  "learn_for_speakers_of": "{{learnLang}} para pessoas que falam {{forLang}}",
  "learn_lang": "Eu quero aprender",
  "leave_classroom": "Sair da sala de aula",
  "leave_classroom_confirmation": "Tem certeza de que deseja excluir esta sala de aula?",
  "leave_course": "Sair do Curso",
  "leave_course_confirmation": "Tem certeza de que deseja sair deste curso?",
  "left_classroom": "Sala de aula esquerda",
  "left_course": "Sair do curso",
  "lets_begin": "Vamos começar",
  "library": "Biblioteca",
  "link_name": "Nome do link",
  "link_name_helper_text": "Digite um nome para exibição para o seu link",
  "link_value": "Link da Url",
  "link_value_helper_text": "Digite o URL do seu link",
  "listen_to_this_phrase": "Escute esta frase em {{language}}",
  "listener_dialog_desc": "Escolha uma voz abaixo para ouvir a pronúncia",
  "listening": "Ouvindo",
  "listening_exercise_desc": "Você pode entender o que está sendo dito?",
  "load_more_events": "Carregar mais eventos",
  "loading": "A carregar",
  "loading_topics": "A carregar tópicos",
  "logout": "Logout",
  "manage_course": "Gerenciar curso",
  "members": "Estudantes",
  "members_not_found": "Sem membros",
  "members_not_found_desc": "Nenhum membro foi encontrado",
  "message": "Mensagem",
  "method": "Método",
  "missing_details": "Faltando detalhes",
  "more_definitions": "Mais definições",
  "more_options": "Mais opções",
  "more_translations": "Mais traduções",
  "my_courses": "Meus cursos",
  "name": "Nome",
  "new": "Novo",
  "next": "Próximo",
  "next_with_progress": "Próximo ({current} de {total})",
  "no_activity_found": "Nenhuma atividade encontrada",
  "no_chatbot_templates": "Sem modelos disponíveis",
  "no_courses_found": "Nenhum curso encontrado",
  "no_phrases": "Sem frases",
  "no_topics_available": "Sem tópicos disponíveis",
  "not_in_game": "Fora do jogo",
  "nualang_templates": "Modelos",
  "nudge_add_family_name_field_desc": "Adicione o seu apelido para que os professores o possam identificar.",
  "nudge_add_family_name_profile_desc": "Adicione o seu apelido ao perfil para que os professores o possam identificar.",
  "nudge_add_family_name_title": "Adicione o seu apelido",
  "on": "em",
  "only_available_on_chrome": "Disponível apenas no Chrome",
  "open_image_library": "Abrir biblioteca de imagens",
  "open_in_google_sheets": "Abrir em Google Planilhas",
  "open_search_student_name_filters": "Open search student name filters",
  "optional": "Opcional",
  "or_choose_from_one_of_the_following": "Ou escolha uma das seguintes opções",
  "percentage_complete": "Percentage Complete",
  "perfect_click_finish_create_group": "Perfeito! Clique em Concluir para criar o seu grupo.",
  "phrase": "Frase",
  "phrase_group_game_in_progress_icon": "{{name}} em curso",
  "phrase_lists_error": "Ocorreu um problema ao carregar as listas de frases",
  "phrases": "Frases",
  "player": "jogador",
  "players": "jogadores",
  "plays": "{{number}} jogadores",
  "please_select_a_textfield": "Selecione um campo de texto",
  "popular_courses": "Cursos populares",
  "preview": "Pré-visualização",
  "preview_pdf": "Pré-visualizar PDF",
  "previous": "Anterior",
  "print": "Imprimir",
  "private": "Privado",
  "problem": "Havia um problema",
  "problem_creating": "Ocorreu um problema ao criar",
  "problem_deleting": "Ocorreu um problema ao excluir",
  "problem_getting_reply": "Ocorreu um problema ao obter resposta",
  "problem_loading": "Ocorreu um problema ao carregar",
  "problem_sending_contact_form": "Problema ao enviar o formulário de contato",
  "profile": "Perfil",
  "profiles": "Perfis",
  "progress_icon": "Ícone de progresso",
  "pronounce_this_phrase": "Pronuncie esta frase",
  "pronunciation": "Pronúncia",
  "pronunciation_exercise_desc": "Pratique pronunciar frases",
  "public": "Público",
  "question": "Questão",
  "new_question_placeholder": "Digite sua pergunta aqui",
  "questions": "Perguntas",
  "quit": "Sair",
  "recommended": "Recomendado",
  "record_message": "Gravar mensagem",
  "record_unsupported": "A gravação não é suportada neste navegador",
  "records": "Records",
  "redo_action": "Refazer",
  "refresh": "Atualizar",
  "remove": "Remover",
  "remove_bot": "Remover Chatbot",
  "remove_card": "Remove Card",
  "remove_roleplay": "Remover encenação",
  "remove_classroom_member": "Remove Classroom Student",
  "remove_classroom_member_confirmation": "Are you sure you want to remove this student from your classroom",
  "remove_member": "Remove Student",
  "member_removed_from_classroom": "Student removed from classroom",
  "reply": "Responder",
  "reply_options": "Opçoes de resposta",
  "reply_options_are_disabled": "As opções de resposta estão desativadas",
  "reply_options_desc": "Permitir que os alunos escolham a resposta correta em uma lista de opções",
  "report_views": "Views",
  "required_for_private_classrooms": "Obrigatório para salas de aula particulares",
  "required_for_private_courses": "Obrigatório para cursos particulares",
  "reset": "redefinir",
  "restart_exercise": "Reinicie o exercício",
  "result": "Resultado",
  "retry": "Tentar novamente",
  "return_to_course": "Voltar ao Curso",
  "review_content": "Revisar conteúdo",
  "review_title": "Título da Revisão",
  "reviews": "Avaliações",
  "reviews_not_found": "Sem comentários",
  "reviews_not_found_desc": "Nenhum comentário foi encontrado",
  "roleplay": "Encenação",
  "roleplay_exercise_desc": "\nSimule e responda a perguntas em conversas entre duas pessoas",
  "roleplay_not_found": "Cenário não encontrado",
  "roleplay_not_found_desc": "Não conseguimos encontrar este cenário. Pode ter sido eliminado ou tornado privado.",
  "roleplays_not_found_desc": "Tente alterar seus parâmetros de pesquisa",
  "roleplay_information": "Informação da encenação",
  "roleplay_name": "Nome da encenação",
  "roleplay_settings": "Definições de encenação",
  "roleplays": "Encenações",
  "save_changes": "Salvar alterações",
  "save_definitions_error": "Ocorreu um problema ao guardar as definições",
  "save_progress": "Salvar Progresso",
  "scenarios": "Cenários",
  "schedule": "Agendar",
  "script_not_found": "Guião não encontrado",
  "script_not_found_desc": "Não conseguimos encontrar este guião. Pode ter sido eliminado ou tornado privado.",
  "search_images": "Procurar imagens",
  "see_more_pronunciations": "Ver mais pronúncias",
  "send": "Enviar",
  "show_phrase_list": "Mostrar lista de frases",
  "show_progress": "Mostrar progresso",
  "script": "Roteiro",
  "search": "Search",
  "search_for_student": "Procurar estudante",
  "section": "Seção",
  "section_name": "Nome da Seção",
  "sections_not_found": "Nenhuma seção encontrada",
  "sections_not_found_desc": "",
  "select_a_template": "Selecione um modelo",
  "select_file": "Selecione o arquivo",
  "select_file_desc": "Solte o arquivo aqui ou clique para navegar na sua máquina",
  "select_files": "Selecionar arquivos",
  "select_the_from_date": "Selecione a data inicial",
  "select_the_to_date": "Selecione Até a data",
  "settings": "Definições",
  "share": "Compartilhar",
  "share_via": "Compartilhar via",
  "show_bot": "Mostrar chatbot",
  "show_chatbots_exercise": "Mostrar robôs de Bate-papo",
  "show_listening_exercise": "Mostrar exercício de escuta",
  "show_menu": "Mostrar Menu",
  "show_options": "Mostrar opções",
  "show_pronunciation_exercise": "Mostrar exercício de pronúncia",
  "show_roleplay": "Mostrar encenação",
  "show_roleplays_exercise": "Mostrar encenação",
  "show_section": "Mostrar seção",
  "show_topic": "Mostrar tópico",
  "show_translation_exercise": "Mostrar exercício de tradução",
  "skip": "Pular",
  "skip_copy_topic": "Pular",
  "speakers_of": "Oradores de",
  "start": "Começar",
  "start_course": "Iniciar curso",
  "stop": "Pare",
  "stop_recording": "Pare de gravar",
  "student_instructions": "Instruções para estudantes",
  "student_instructions_placeholder": "Instruções para estudantes:\nVocê pode adicionar sua mensagem de instruções formatada aqui \n\ne.g. \"Bem-vindo ao chatbot, você pode começar digitando olá \"",
  "student_limit": "Limite de alunos",
  "subject": "Sujeito",
  "submit": "Submeter",
  "submitting": "A submeter",
  "subscription": "Subscrição",
  "subscription_period_end": "Fim do período de subscrição",
  "subscription_status": "Estado da subscrição",
  "substitution_desc": "Faça alterações na mensagem do usuário antes de verificar os gatilhos.",
  "substitution_name": "Texto original",
  "substitution_name_helper_text": "O texto original que pode aparecer na mensagem do usuário",
  "substitution_value": "Texto de substituição",
  "substitution_value_helper_text": "Não deve conter símbolos ou pontuação especiais e também deve estar em minúsculas",
  "substitutions": "Substituições",
  "table": "Tabela",
  "thank_you_for_submitting": "Obrigado por enviar, entraremos em contato com você o mais breve possível. Voltando à página inicial",
  "the_default_topic_is_random": "O tópico padrão é aleatório",
  "to": "Para",
  "toggle_theme": "Alternar tema claro / escuro",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "topic": "Tópico",
  "topic_code": "Código do tópico",
  "topic_desc": "Quando um usuário está em um tópico, ele pode corresponder apenas a gatilhos que pertencem a esse tópico.",
  "topic_image": "Imagem do tópico",
  "topic_information": "Informações sobre o tópico",
  "topic_name": "Nome do tópico",
  "topic_not_found": "Tópico não encontrado",
  "topic_not_found_desc": "Este tópico pode ter sido excluído",
  "topics": "Tópicos",
  "translate": "Traduzir",
  "translate_is_disabled": "A tradução está desativada",
  "translate_this_phrase": "Traduza esta frase",
  "translation": "Tradução",
  "translation_exercise_desc": "Teste suas habilidades no idioma traduzindo frases",
  "translations": "Traduções",
  "trigger_value": "Disparar texto",
  "trigger_value_helper_text": "Não deve conter símbolos ou pontuação especiais e também deve estar em minúsculas",
  "triggers": "Gatilhos",
  "triggers_desc": "Um gatilho é uma linha de texto usada para corresponder à mensagem do usuário.",
  "type": "Tipo",
  "unarchive": "Desarquivar",
  "undo_action": "Desfazer",
  "update": "Atualizar",
  "update_image": "Atualizar imagem",
  "update_link": "Atualizar ligação",
  "update_phrase": "Atualizar frase",
  "update_phrase_desc": "Faça alterações nesta frase existente",
  "update_picture": "Atualizar imagem",
  "update_question": "Atualizar pergunta",
  "update_question_desc": "Faça uma pergunta de compreensão. A pergunta pode ter várias respostas corretas.",
  "update_recording_error": "Ocorreu um problema ao atualizar a gravação",
  "update_review": "Revisão de atualização",
  "update_review_desc": "Descrição da revisão de atualização",
  "upgrade": "Atualizar plano",
  "upload_script": "Script De Upload",
  "upload_script_desc": "Carregue um script de roleplay com um arquivo csv usando o formato mostrado abaixo",
  "update_section": "Seção de atualização",
  "update_section_desc": "Cabe a você estruturar o curso. As estruturas de exemplo são 'Iniciante, Intermediário, Avançado' ou 'Semana 1, Semana 2, Semana 3'",
  "update_substitution": "Atualizar substituição",
  "update_topic": "Atualizar tópico",
  "update_trigger": "Gatilho de atualização",
  "update_variable": "Atualizar variável",
  "upload_phrases": "Carregar frases",
  "upload_phrases_desc": "Crie e envie um arquivo csv como o exemplo abaixo.",
  "upload_phrases_example_phrase_1": "olá",
  "upload_phrases_example_phrase_2": "adeus",
  "upload_phrases_example_phrase_3": "meu nome é",
  "upload_phrases_example_definition_1": "Uma palavra usada para cumprimentar alguém",
  "upload_phrases_example_definition_2": "Uma palavra usada ao se despedir de alguém",
  "upload_phrases_example_definition_3": "Uma frase usada para dizer o seu nome a alguém",
  "use_keyboard": "Usar teclado",
  "use_word_bank": "Usar banco de palavras",
  "user_message": "Mensagem do Usuário",
  "user_updated": "Usuário atualizado",
  "variable_desc": "Informações que podem ser usadas no seu chatbot.",
  "variable_name": "Nome variável",
  "variable_value": "Valor variável",
  "variables": "Variáveis",
  "vars": "Variáveis",
  "view_activity": "Ver atividade",
  "view_instruction_message": "Ver instruções",
  "view_outline": "Exibir Esboço",
  "view_progress": "Ver Progresso",
  "visibility": "Visibilidade",
  "visit_learning_site": "Visitar o Learning Site",
  "voice_speed_disabled": "A velocidade de voz não está disponível para esta voz",
  "weekly_progress": "Progresso semanal",
  "what_do_you_hear": "O que você ouve?",
  "answer_method": "Método de Resposta",
  "answers": "Respostas",
  "attempt_info": "Informação de tentativa",
  "bot_outputs": "Saídas do chatbot",
  "creator_instructions": "Instruções do professor",
  "creator_instructions_placeholder": "Você pode adicionar uma mensagem de instrução formatada para um colaborador do curso aqui, por exemplo Bem-vindo ao chatbot. Aqui está como personalizar para seus alunos ...",
  "date": "Encontro",
  "fri": "Sex",
  "listener": "Ouvinte",
  "mon": "seg",
  "new_bots": "Novos Chatbots",
  "new_courses": "Novos Cursos",
  "new_roleplays": "Novos Roleplays",
  "no_results_found": "Nenhum resultado encontrado",
  "option": "Opção",
  "play_again": "Jogar de novo",
  "role_played": "Role Played",
  "sat": "Sentou",
  "show_word_bank": "Mostrar Banco de Palavras",
  "skipped": "Pulado",
  "speak": "Falar",
  "sun": "Sol",
  "text": "Texto",
  "thu": "qui",
  "time": "Tempo",
  "time_spent": "Tempo gasto",
  "tue": "ter",
  "view_report": "Ver relatório",
  "voice": "Voz",
  "wed": "Casar",
  "word_bank": "Banco Mundial",
  "teach": "Ensinar",
  "active_now": "Ativar agora",
  "manage_classroom": "Gerenciar sala de aula",
  "must_question_least_correct_answer": "Deve ser uma pergunta e pelo menos uma resposta correta.",
  "enter_name_your_voice_clip": "Digite um nome para o seu clipe de voz?",
  "my_unnamed_clip": "Meu clipe sem nome",
  "are_you_sure": "Você tem certeza?",
  "is_already_created_variable_overwrite": "já é uma variável criada, deseja sobrescrevê-la?",
  "is_already_created_substitution_overwrite": "já é uma substituição criada, deseja sobrescrevê-la?",
  "is_already_created_alternative_overwrite": "já é uma alternativa criada, deseja sobrescrevê-la?",
  "is_already_created_topic_overwrite": "já é um tópico criado, deseja substituí-lo?",
  "bring_your_bot_picture_name": "Dê vida ao seu chatbot, dando-lhe uma imagem e um nome",
  "perfect_click_finish_create_bot": "Perfeito, clique em Concluir para criar seu novo chatbot",
  "lets_start_with_some_information_about_your_bot": "Vamos começar com algumas informações sobre o seu chatbot",
  "lets_start_some_information_about_classroom": "Vamos começar com algumas informações sobre sua sala de aula",
  "the_language_classroom_teach": "O idioma que esta sala de aula vai ensinar",
  "the_language_students_classroom_speak": "A língua que os alunos desta sala falam",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Limite o acesso à sua sala de aula definindo a visibilidade como privada e incluindo uma chave de inscrição",
  "add_collaborators": "Adicionar colaboradores",
  "perfect_click_finish_create_classroom": "Perfeito, clique em Concluir para criar sua nova sala de aula",
  "perfect_click_finish_create_course": "Perfeito, clique em Concluir para criar seu novo curso",
  "lets_start_information_about_course": "Vamos começar com algumas informações sobre o seu curso",
  "the_language_course_teach": "O idioma que este curso vai ensinar",
  "the_language_students_course_speak": "A língua que os alunos deste curso falam",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Limite o acesso ao seu curso definindo a visibilidade como privada e incluindo uma chave de inscrição",
  "selected": "Selecionado",
  "perfect_click_finish_create_roleplay": "Perfeito, clique em Concluir para criar seu novo RPG",
  "lets_start_with_information_about_roleplay": "Vamos começar com algumas informações sobre sua interpretação",
  "invite": "Convidar",
  "topic_settings": "Configurações de tópico",
  "topic_title": "Título do Tópico",
  "unanswered_table": "Sem resposta",
  "create_roleplay": "Criar roleplay",
  "roleplays_not_found_title": "Roleplays não encontrados",
  "play": "Jogar",
  "delete": "Excluir",
  "delete_picture": "Excluir Imagem",
  "use_wordbank_if_stuck": "Use o banco de palavras se você precisar de ajuda",
  "play_bot_error": "Ops! Ocorreu um problema com o chatbot, tente novamente",
  "bot_editor_preview_error": "Ocorreu um erro. Visite https://nualang.com/guides/create-a-bot para obter um guia sobre como criar um chatbot",
  "manage_courses": "Gerir Cursos",
  "refresh_courses": "Atualizar Cursos",
  "customize_appearance_of_course": "Personalize a aparência do curso",
  "customize_appearance_of_classroom": "Personalize a aparência da sala de aula",
  "customize_appearance_of_topic": "Customize the appearance of the topic",
  "create_duplicate": "Criar Duplicado",
  "section_visibility": "Visibilidade da seção",
  "choose_a_language": "Escolha um idioma",
  "play_bot": "Jogar chatbot",
  "lets_find_a_template": "Vamos encontrar um modelo!",
  "search_by_difficulty": "Pesquise por dificuldade",
  "search_using_keywords": "Pesquise usando palavras-chave",
  "select_a_nualang_template": "Selecione um modelo Nualang",
  "select_a_nualang_template_desc": "Modelos criados pela equipe Nualang para ajudá-lo a começar.",
  "or_select_a_community_template": "Ou selecione um modelo de comunidade",
  "or_select_a_community_template_desc": "Os modelos de comunidade são criados por professores em todo o mundo.",
  "dashboard_welcome": "Bem-vindo, {{name}}!",
  "dashboard_welcome_desc": "Familiarize-se com o painel, aqui estão algumas maneiras de começar.",
  "enter_course_code": "Insira um código de curso",
  "enter_course_code_desc": "Se você tiver um código de curso, insira-o aqui.",
  "enter_classroom_code": "Digite um código de sala de aula",
  "enter_classroom_code_desc": "Se você tiver um código de sala de aula, insira-o aqui.",
  "search_nualang": "Explore Nualang",
  "search_nualang_desc": "Há uma comunidade crescente de professores com ideias semelhantes desenvolvendo conversas com nossos Nualas, então sempre há algo novo para aprender.",
  "create_nualang": "Crie seu próprio",
  "create_nualang_desc": "Crie conversas e aulas de idiomas.",
  "roleplay_editor_welcome": "Introdução ao Roleplay Editor",
  "roleplay_editor_options": "Selecione uma opção",
  "roleplay_editor_options_desc": "Escolha um Nuala para adicionar uma nova linha ou adicione uma pergunta de compreensão.",
  "roleplay_editor_share": "Compartilhar roleplay",
  "roleplay_editor_play": "Jogue RPG",
  "bot_editor_welcome": "Primeiros passos com o Chatbot Editor",
  "bot_editor_sidebar": "Barra lateral do editor",
  "bot_editor_sidebar_desc": "A barra lateral é onde você poderá fazer alterações em seu chatbot.",
  "bot_editor_flow_chart": "Fluxo de chatbot",
  "bot_editor_flow_chart_desc": "O fluxo do chatbot mostra uma visão geral do seu chatbot e dá uma prévia de como será a aparência de cada mensagem.",
  "bot_editor_share": "Chatbot de compartilhamento",
  "bot_editor_play": "Jogar chatbot",
  "play_roleplay": "Jogar Roleplay",
  "delete_script_item": "Excluir item do script",
  "delete_script_item_confirmation": "Tem certeza de que deseja excluir este item do script?",
  "add_message": "Adicionar mensagem",
  "resources": "Recursos",
  "contact": "Contato",
  "sign_in": "Conecte-se",
  "sign_up": "Inscrever-se",
  "faqs": "FAQs",
  "guides": "Tutoriais",
  "back_to_app": "Voltar ao aplicativo",
  "notes": "Notas",
  "notes_placeholder": "Insira as notas aqui",
  "get_in_touch": "Entre em contato",
  "get_in_touch_desc": "Você tem perguntas ou comentários? Envie-nos uma mensagem.",
  "avatar_generator": "Avatar Generator",
  "avatar_generator_desc": "Faça seu próprio avatar pessoal",
  "upload_image": "Carregar imagem",
  "upload_image_desc": "Arraste e solte a imagem do seu computador",
  "random": "Random",
  "done": "Pronto",
  "file_size_exceeded": "Imagem muito grande! Faça upload de uma imagem menor que ",
  "image_selection_failed": "Não foi possível carregar essa imagem. Tente outra ou faça upload da sua.",
  "remove_course": "Remover Curso",
  "courses_joined": "Cursos ingressados",
  "classroom_courses_not_found_title": "Nenhum curso ainda",
  "classroom_courses_not_found_desc": "Esta sala de aula ainda não possui cursos.",
  "in_progress_activity": "Em progresso",
  "bot_exercise_welcome": "Introdução ao exercício do chatbot",
  "bot_exercise_restart": "Reinicie o chatbot!",
  "bot_exercise_keyboard_input": "Digite!",
  "bot_exercise_keyboard_input_desc": "Use o teclado para digitar uma mensagem. Se precisar de ajuda com caracteres especiais ou quiser adicionar um emoji, experimente nossos botões úteis.",
  "bot_exercise_voice_input": "Fale!",
  "bot_exercise_voice_input_desc": "Clique no microfone para usar sua voz e praticar sua pronúncia.",
  "bot_exercise_send_message": "Envie!",
  "bot_exercise_send_message_desc": "Envie uma mensagem ao chatbot e dê início à conversa.",
  "bot_exercise_audio_only_mic": "Fale!",
  "bot_exercise_audio_only_mic_desc": "Toque no microfone para começar. Depois disso, fale naturalmente — a Nuala vai ouvir e responder automaticamente pelo resto da conversa.",
  "roleplay_exercise_welcome": "Introdução ao exercício de representação",
  "roleplay_exercise_read_script": "Aprenda suas falas!",
  "roleplay_exercise_read_script_desc": "Leia a conversa e ouça como as palavras são pronunciadas.",
  "roleplay_exercise_select_an_actor": "Escolha sua função!",
  "roleplay_exercise_select_an_actor_desc": "Selecione a função que você gostaria de desempenhar.",
  "roleplay_exercise_start": "Faça uma representação!",
  "roleplay_exercise_start_desc": "Clique em iniciar e use o teclado ou voz para representar a função que você escolheu.",
  "listening_exercise_welcome": "Introdução ao exercício de escuta",
  "listening_exercise_speak": "Ouça a frase!",
  "listening_exercise_speak_desc": "Clique para ouvir como a frase é pronunciada.",
  "listening_exercise_voice_options": "Ouça uma voz diferente!",
  "listening_exercise_voice_options_desc": "Ouça a frase dita em vozes diferentes.",
  "listening_exercise_keyboard_input": "Digite a resposta!",
  "listening_exercise_keyboard_input_desc": "Use o teclado para digitar a frase que você ouve.",
  "listening_exercise_word_bank": "Precisa de ajuda?",
  "listening_exercise_word_bank_desc": "Use o banco de palavras para selecionar a resposta correta.",
  "translation_exercise_welcome": "Introdução ao exercício de tradução",
  "translation_exercise_speak": "Ouça a frase!",
  "translation_exercise_speak_desc": "Clique para ouvir como a frase é pronunciada.",
  "translation_exercise_read": "Leia a frase!",
  "translation_exercise_read_desc": "Leia a frase a ser traduzida.",
  "translation_exercise_keyboard_input": "Digite a resposta!",
  "translation_exercise_keyboard_input_desc": "Use o teclado para digitar a tradução.",
  "translation_exercise_word_bank": "Precisa de ajuda?",
  "translation_exercise_word_bank_desc": "Use o banco de palavras para selecionar a resposta correta.",
  "pronunciation_exercise_welcome": "Introdução ao Exercício de Pronúncia",
  "pronunciation_exercise_speak": "Ouça a frase!",
  "pronunciation_exercise_speak_desc": "Clique para ouvir como a frase é pronunciada.",
  "pronunciation_exercise_read": "Leia a frase!",
  "pronunciation_exercise_read_desc": "Leia a frase a ser pronunciada.",
  "pronunciation_exercise_voice_input": "Pronuncie a frase!",
  "pronunciation_exercise_voice_input_desc": "Clique no microfone para usar sua voz e praticar sua pronúncia.",
  "exercise_share": "Compartilhe com outras pessoas!",
  "exercise_mute": "Silenciar o som!",
  "exercise_skip": "Pule!",
  "exercise_skip_desc": "Passe para a próxima frase, você poderá tentar novamente no final.",
  "exercise_restart": "O que você gostaria de fazer?",
  "what_would_you_like_to_do": "O que você gostaria de fazer?",
  "i_want_to_learn": "Eu quero aprender...",
  "i_want_to_teach": "Eu quero ensinar...",
  "add_alternative_version": "Adicionar versão alternativa",
  "language_translation_helper_text": "Pressione a tecla Enter / Return para adicionar tradução.",
  "change_roles": "Mudar de função?",
  "write_your_feedback_here": "Escreva aqui o seu comentário",
  "yes": "Sim",
  "you_are_human_check": "Confirme que é humano",
  "you_will_lose_your_progress_on_this_exercise": "Você perderá seu progresso neste exercício",
  "confirm": "Confirmar",
  "general": "Geral",
  "shuffle_phrases": "Frases aleatórias",
  "shuffle_phrases_desc": "Randomize a ordem em que as perguntas são feitas nos exercícios.",
  "errors": "Erros",
  "missing_translation": "Faltando tradução",
  "missing_phrase": "Frase ausente",
  "invalid_image_domain": "O URL da imagem deve ser de um domínio Nualang aprovado",
  "row": "Linha",
  "no_valid_type": "O tipo deve ser 'actor' ou 'question'",
  "no_actor_text": "Sem texto para ator",
  "no_actor_number": "O ator deve ter um número no final, por exemplo actor1, actor2",
  "no_question": "Sem dúvida",
  "no_answers_provided": "Nenhuma resposta fornecida",
  "no_correct_answer_provided": "Nenhum provedor de resposta correta",
  "no_answers": "Sem respostas",
  "duplicate_topic": "Tópico Duplicado",
  "normal_mode": "Modo normal",
  "spreadsheet_mode": "Modo de planilha",
  "image": "Imagem",
  "delete_selected_row": "Excluir linha selecionada",
  "crop_image": "Cortar imagem",
  "crop": "Colheita",
  "zoom": "Ampliação",
  "rotate": "Girar",
  "hide_preview": "Esconder a Antevisão",
  "show_preview": "Mostrar Antevisão",
  "try_again": "Tente Novamente",
  "confidence_score": "A porcentagem de confiança indica a probabilidade de as palavras individuais serem reconhecidas corretamente.",
  "subscription_plan_teach": "Teach Plan",
  "subscription_plan_teacher_pro": "Teacher PRO",
  "subscription_plan_basic": "Teacher Basic",
  "subscription_plan": "Subscription Plan",
  "subscription_status_trialing": "Free Trial",
  "subscription_status_active": "Active",
  "subscription_status_canceled": "Canceled",
  "subscription_status_undefined": "Free",
  "status": "Status",
  "upgrade_plan": "Upgrade Plan",
  "manage_plan": "Manage Plan",
  "cancel_plan": "Cancel Plan",
  "your_plan": "Your Plan",
  "plan_cost": "Plan Cost",
  "next_billing_date": "Current Period End",
  "free": "Free",
  "payment_method": "Payment Method",
  "pricing_page_title": "Choose your plan",
  "pricing_page_subtitle": "Pricing plans for teachers, schools and districts.",
  "pricing_page_testimonials_title": "What Teachers are saying",
  "compare_plans": "Compare Plans",
  "features": "Features",
  "upgrade_submit": "Upgrade",
  "upgrade_subscription_desc": "To access this feature you need to upgrade your account. Click Upgrade to be taken to the pricing page.",
  "upgrade_plan_explanation": "To access this feature you need to upgrade your account.",
  "upgrade_subscription_student": "This feature is available to teachers only.",
  "public_visibility_disabled_wayside": "As salas de aula são gerenciadas pela Wayside Publishing e devem permanecer privadas.",
  "public_visibility_disabled_loading": "Ainda estamos verificando sua subscrição. Atualize a página se isso não mudar.",
  "public_visibility_disabled_trial": "Salas de aula públicas não estão disponíveis durante o teste gratuito. Atualize para um plano pago para tornar esta sala de aula pública.",
  "creator_not_subscribed": "This content is not joinable as the creator is not currently subscribed.",
  "first_name": "First Name",
  "last_name": "Last Name",
  "role": "Role",
  "school_name": "School Name",
  "school_district": "School District",
  "city": "City",
  "state": "State",
  "send_message": "Send Message",
  "sign_me_up": "Sign me up!",
  "free_trial": "FREE Trial",
  "interactive_demo": "Interactive Demo",
  "news_and_updates": "News and Updates",
  "teacher": "Teacher",
  "principal": "Principal",
  "tutor": "Tutor",
  "parent": "Parent",
  "student": "Student",
  "other": "Other",
  "none": "None",
  "group_subscription_plans": "Group Subscription Plans",
  "group_plan": "Group Plan",
  "leave_group": "Leave Group",
  "joined_subscription": "Joined subscription",
  "joined_subscription_desc": "Welcome to the {{groupName}} group subscription, you are now using Teacher PRO!",
  "unable_to_join_subscription": "Unable to join subscription",
  "unable_to_join_subscription_desc": "There was an issue joining subscription, please try again later.",
  "unable_to_join_subscription_invalid_email_desc": "You cannot join this group without having one of the allowed email domains: {{allowedDomains}}",
  "unable_to_join_subscription_limit_reached_desc": "'{{groupName}}' has reached it's student limit, contact the group admin to increase the limit.",
  "moderated_image_dialog": "Nualang detected an image that was inappropriate, unwanted, or offensive and blocked it to provide a safer user experience. Please try a different image.",
  "moderate_title": "Image Blocked",
  "recommended_courses": "Recommended Courses",
  "subscription_status_trialing_expired": "Free Trial Expired",
  "no_public_content_created": "No public content created",
  "add_tag": "Press enter / return key to add a tag",
  "add_collaborator_tag": "Press enter / return key to add a collaborator",
  "add_to_classroom": "Add to classrooms",
  "add_to_classroom_desc": "Add '{{courseName}}' to {{classroomNames}}.",
  "change_voice_speed": "Change the voice speed!",
  "extra_fast": "Super speed",
  "fast": "Very fast talker",
  "medium": "Normal speed",
  "slow": "Slow it down a bit",
  "extra_slow": "One word at a time",
  "card_ALL": "All",
  "join_classroom_to_access": "Join classroom to access",
  "join_course_to_access": "Join course to access",
  "confidence": "Confidence",
  "teach_lang": "I want to teach",
  "write_feedback": "Write Feedback",
  "allowed_domains": "Allowed school domains (optional)",
  "add_allowed_domains_desc": "Restrict access based on school domain e.g 'schooldomain.com'",
  "send_feedback": "Send Feedback",
  "add_feedback": "Add Feedback",
  "feedback_content": "Feedback Content",
  "report_problem": "Report problem",
  "report_problem_input_label": "Problem description",
  "update_feedback": "Update Feedback",
  "student_completes_exercise": "A student completes an exercise",
  "delete_feedback_confirmation": "Are you sure you want to delete this feedback?",
  "delete_feedback": "Delete Feedback",
  "updates_to_our_terms_of_service": "Updates to our Terms of Service",
  "email_me_when": "Email me when:",
  "new_classroom": "New Classroom",
  "student_progress": "Student Progress",
  "view_course": "View Course",
  "view_section": "View Section",
  "classroom_members_not_found_title": "No students yet",
  "classroom_members_not_found_desc": "This classroom does not have any students yet.",
  "open_topic": "Open Topic",
  "click_to_speak": "click to speak",
  "click_to_stop": "click to stop",
  "listening_indicator": "Listening ...",
  "save_recording_to_report": "Save recording to report",
  "no_voice_recording_saved": "Voice recording was not saved",
  "classrooms_not_created": "No classrooms created",
  "select_a_classroom": "Select a classroom",
  "voice_attempt": "Voice attempt",
  "upload_variables": "Upload variables",
  "next_game": "Next Game",
  "roleplay_games": "Roleplay Games",
  "roleplay_games_description": "Click on one of the cards below to play a specific game",
  "choose_game_mode": "Choose a game mode",
  "story": "Story",
  "story_description": "Listen to the conversation between the characters and answer questions to test your understanding.",
  "fill_in_blanks": "Fill in the blanks",
  "fill_in_blanks_description": "Can you correctly identify what's missing?",
  "fill_in_the_blanks": "Fill in the blanks",
  "fill_in_the_blanks_description": "Can you correctly identify what's missing?",
  "act_it_out": "Act it out",
  "act_it_out_description": "Can you select the correct response?",
  "act_it_out_listening": "Act it out - Listening",
  "act_it_out_listening_description": "Use your listening skills to select the correct response.",
  "act_it_out_speaking": "Act it out - Speaking",
  "act_it_out_speaking_description": "Practice your pronunciation by speaking your part.",
  "act_it_out_listening_speaking": "Act it out - Listening and Speaking",
  "act_it_out_listening_speaking_description": "Practice your pronunciation by speaking your part.",
  "select_role": "Select your role",
  "select_role_description": "Select the role you would like to play.",
  "mute": "Mute",
  "unmute": "Unmute",
  "replay": "Restart",
  "restart": "Restart",
  "group_courses": "Group courses",
  "select": "Select",
  "classroom_creator_welcome": "Getting started with your classroom",
  "classroom_creator_welcome_free_trial": "Welcome to your 30 day free trial of Nualang! To get you started, we have setup your first classroom.",
  "classroom_creator_add_courses": "Add courses",
  "classroom_creator_add_courses_desc": "Choose how you want to add courses to the classroom.",
  "classroom_creator_add_students_email": "Invite students",
  "classroom_creator_track_progress": "Track student activity",
  "classroom_creator_track_progress_desc": "Once students have joined the classroom, click to view their progress on the courses which have been added.",
  "forLang_and_learnLang_the_same": "Learn language and speaker language are the same. Translation exercise is disabled as a result",
  "english": "Inglês",
  "french": "Francês",
  "german": "Alemão",
  "irish": "Irlandês",
  "italian": "Italiano",
  "portuguese": "Português",
  "spanish": "Espanhol",
  "close": "Terminar",
  "last": "Último",
  "classroom": "Sala de aula",
  "update_avatar": "Update Avatar",
  "update_avatar_desc": "Update your personal avatar",
  "invite_students": "Invite Students",
  "share_student_link_desc": "Share the instructions below to invite students to join.",
  "invite_link_desc": "Please sign in or create an account on Nualang by clicking this invite link:",
  "join_instructions_1": "This will bring you to the ",
  "join_instructions_2": "I created for you, where you'll have to click ‘Join’",
  "enrollment_key_text": "and input the key: ",
  "copy_student_instructions": "Copy student instructions",
  "or_invite_via": "Or invite via",
  "invite_email_subject": "Invitation to join a Nualang",
  "dear_students": "Dear Students",
  "dashboard": "Dashboard",
  "preview_roleplay": "Preview Roleplay",
  "roleplay_preview": "Preview",
  "roleplay_preview_decription": "Preview the full roleplay script",
  "sort": "Sort",
  "sort_by": "Ordenar por",
  "newest": "Mais recente",
  "alphabetical": "Alfabético",
  "recently_changed": "Modificado recentemente",
  "recently_viewed": "Visto recentemente",
  "oldest": "Mais antigos",
  "default": "Predefinido",
  "clear_filters": "Limpar filtros",
  "member": "Student",
  "stop_speaking": "Stop Speaking",
  "agree_to_terms_and_conditions_1": "I agree to the ",
  "nualang_terms": "Nualang terms",
  "agree_to_terms_and_conditions_2": ", including acceptance of our ",
  "privacy_policy": "Privacy and Data Protection policy",
  "first_classroom_description": "This is a classroom to help students speak {{learnLang}} with confidence.",
  "upload": "Upload",
  "download": "Download",
  "bot_sign_in_message": "You must be signed in to play this chatbot",
  "course_sign_in_to_access": "Sign in to access this course",
  "have_an_account": "Have an account?",
  "provide_a_little_more_information": "Provide a little more information",
  "instructions": "Instructions",
  "close_preview": "Close Preview",
  "classroom_creator_add_students_email_desc": "Click to explore different ways to invite students to your classroom.",
  "check_recognition": "Check speech recognition",
  "checking_recognition": "Checking speech recognition ...",
  "phrase_recognised": "Phrase recognised",
  "phrase_not_recognised": "Phrase not recognised",
  "speech_recognition_info": " Checking the speech recognition allows you to determine whether or not your students will have difficulty pronouncing this phrase in our exercises.",
  "speech_recognition_error_info": "We recognised your phrase as {{recognisedPhrase}}. We recommend that you reword the phrase and/or add an alternative version.",
  "my_library": "My Library",
  "add_own_exercise_message": "Create new {{exerciseName}} using templates created by you",
  "no_exercises_in_library": "There are no {{exerciseName}} created by you.",
  "classroom_invite_feature_disabled_message": "This feature is disabled because your students will be able to join this classroom automatically.",
  "skip_navigation": "Skip Navigation",
  "generate_roleplay": "Generate Roleplay",
  "choose_topic_for_roleplay": "Choose a topic for the roleplay",
  "roleplay_generated": "Roleplay Generated",
  "select_roleplay": "Select Roleplay",
  "chatgpt_roleplay_description": "This is a roleplay about {{topic}}",
  "check_answer": "Check Answer",
  "card": "Carta",
  "banner": "Bandiera",
  "load_more": "Load More",
  "bot_input_placeholder": "Use the keyboard to type a message",
  "bot_input_mobile_placeholder": "Type a message...",
  "audio_only_mode": "Ouvir e Falar",
  "audio_only_tooltip": "Mudar para o modo somente áudio",
  "switch_to_text": "Mudar para texto",
  "switch_to_text_tooltip": "Voltar ao modo de texto",
  "audio_only_title": "Fale com {{botName}}",
  "audio_only_subtitle": "Uma conversa totalmente falada — sem texto algum. Fones de ouvido recomendados.",
  "audio_only_mode_unavailable_fallback_chat": "Este exercício requer o modo Ouvir e Falar, mas não está disponível neste dispositivo — continuará no modo Chat.",
  "microphone_ready": "Microfone pronto",
  "bot_is_speaking": "Falando...",
  "thinking_indicator": "Pensando...",
  "start_conversation": "Iniciar a conversa",
  "stop_button_label": "Parar",
  "stop_bot_message": "Parar a voz do chatbot",
  "choose_mode_text_option": "Chat",
  "choose_mode_text_option_desc": "Digite ou fale suas respostas e leia ou ouça as respostas do bot.",
  "bot_mode_in_progress_icon": "{{mode_name}} conversation currently in progress",
  "bot_mode_completed_icon": "{{mode_name}} completed {{counter}} time",
  "bot_modes_completed_icon": "{{mode_name}} completed {{counter}} times",
  "replay_button_label": "Repetir",
  "replay_bot_message": "Repetir a mensagem do chatbot",
  "you": "Você",
  "ready_when_you_are": "Pronto quando quiser",
  "bot_speaking_banner": "{{botName}} está falando",
  "listening_to_you": "Ouvindo você",
  "bot_thinking_banner": "{{botName}} está pensando",
  "one_moment": "Um momento",
  "listen_first": "Ouça primeiro",
  "tap_when_done": "Toque quando terminar",
  "conversation_complete": "Conversa concluída",
  "exchanges_label": "Trocas",
  "time_spoken_label": "Tempo falado",
  "review_your_turns": "Revise suas falas",
  "submit_to_teacher": "Enviar ao professor",
  "great_job": "Muito bem!",
  "or": "or",
  "choose_difficulty_of_roleplay": "Choose a difficulty for the roleplay",
  "child": "Child",
  "game_visibility": "Game Visiblity",
  "duplicate_course": "Duplicate Course",
  "amount_must_not_exceed_10": "Amount must not exceed 10",
  "amount_must_be_greater_than_0": "Amount must be greater than 0",
  "voice_pitch": "Voice Pitch",
  "voice_pitch_example": "Olá, meu nome é {{name}}",
  "voice_pitch_disabled": "Adjusting the pitch is not possible for this voice.",
  "voice_pitch_x_low": "Very Low",
  "voice_pitch_low": "Low",
  "voice_pitch_medium": "Medium",
  "voice_pitch_high": "High",
  "voice_pitch_x_high": "Very High",
  "contact_us": "Contact Us",
  "contact_us_message": "Thank you for using Nualang. Please send your message below and we will get back to you at the earliest.",
  "expected_phrases": "Expected Phrases",
  "expected_phrases_info": "Phrases you expect your students to use during the exercise that you'd like to be recognised correctly when the student speaks. For example, if the exercise was about the weather you might want to recognise the word 'weather' more often than 'whether'",
  "add_expected_phrases": "Add Expected Phrases",
  "phrase_length_exceeded_error": "Phrase should not exceed 100 characters",
  "whats_new": "What's New",
  "wayside_subscription_message": "Your subscription is managed by Wayside Publishing",
  "select_the_correct_answer": "Select the correct answer",
  "pronunciation_score": "Pronunciation score",
  "pronunciation_score_explanation": "The pronunciation score is based on the number of words recognised correctly ({{transcriptCompletenessPercentage}}%) and how clearly they were recognised.",
  "add_course": "Add Course",
  "generate_roleplay_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "experimental_feature_desc": "New AI Feature - We would love to hear your feedback",
  "generating_roleplay": "Generating Roleplay",
  "updated": "Updated",
  "exercise_completed": "Exercise Completed",
  "exercise_not_completed": "Exercise Not Completed",
  "view_topic": "View Topic",
  "view_roleplay": "View Roleplay",
  "view_bot": "View Chatbot",
  "student_reports_problem": "A student reports a problem during an exercise",
  "problem_reported": "Problem reported",
  "remove_course_confirmation": "Are you sure you want to remove this course?",
  "classroom_member_limit_reached": "Classroom has reached its student limit",
  "upload_pdf": "Upload PDF",
  "remove_pdf": "Remove PDF",
  "classroom_updated": "Classroom Updated",
  "deleted": "Deleted",
  "created": "Created",
  "moderation_warning": "The following categories were detected in your uploaded image(s): ",
  "warning": "Warning",
  "use_anyways": "Use Anyways",
  "view_pdf": "View Story",
  "schedule_discussion": "Schedule discussion",
  "video_chat": "Video Chat",
  "video_chat_member": "Video Chat Member",
  "create_meeting": "Create meeting",
  "group_assignment": "Group assignment",
  "join_group": "Join Group",
  "groups": "Groups",
  "group": "Group",
  "welcome": "Welcome",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "course_updated": "Course updated",
  "overwrite_phrases": "Overwrite Phrases",
  "roleplay_game_in_progress_icon": "Roleplay game currently in progress",
  "roleplay_game_completed_icon": "Roleplay game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Roleplay game has been completed {{counter}} times",
  "page": "Page",
  "unknown": "Desconhecido",
  "add_a_discussion_topic": "Adicionar um Tópico de Discussão",
  "add_a_discussion_prompt": "Adicionar um Estímulo de Discussão",
  "add_a_url_for_students_to_discuss": "Adicionar um URL para os Alunos Discutirem",
  "images_that_students_can_use_as_a_background_during_the_call": "Imagens que os Alunos Podem Usar como Plano de Fundo Durante a Chamada",
  "discussion_images": "Imagens de Discussão",
  "images_for_students_to_discuss_during_the_call": "Imagens para os Alunos Discutirem Durante a Chamada",
  "recording_time": "Tempo de Gravação",
  "due_date": "Data de Vencimento",
  "interculturarity": "Interculturalidade",
  "comprehensibility": "Compreensibilidade",
  "function_and_text_type": "Função e Tipo de Texto",
  "vocabulary_in_context": "Vocabulário em Contexto",
  "Drag_and_drop_image_from_your_computer": "Arraste e Solte uma Imagem do seu Computador",
  "record_time_limit": "Limite de Tempo de Gravação",
  "schedule_discussion_options": "Opções de Agendamento de Discussão",
  "chat_options": "Opções de Chat",
  "recording_info": "Submission Info",
  "discussion_id": "ID de Discussão",
  "discussion_prompt": "Prompt de Discussão",
  "attendees": "Participantes",
  "created_discussions": "Discussões Criadas",
  "create_groups": "Criar Grupos",
  "select_all": "Selecionar Tudo",
  "remove_group": "Remover Grupo",
  "grouped_discussions": "Discussões Agrupadas",
  "no_recordings_found": "Nenhuma Gravação Encontrada",
  "recordings": "Gravações",
  "scheduled_meetings": "Reuniões Agendadas",
  "no_meetings_scheduled": "Nenhuma Reunião Agendada",
  "discussion_info": "Informações da Discussão",
  "invites": "Convites",
  "invited_members": "Membros Convidados",
  "minute": "Minuto",
  "feedback": "Feedback",
  "view": "Visualizar",
  "no_data_found": "Nenhum Dado Encontrado",
  "no_past_discussions_found": "Nenhuma Discussão Passada Encontrada",
  "no_submissions_found": "Nenhuma Submissão Encontrada",
  "no_scheduled_discussions_found": "Nenhuma Discussão Agendada Encontrada",
  "view_more": "Ver Mais",
  "past": "Passado",
  "submissions": "Submissões",
  "background_images": "Imagens de Fundo",
  "join_live_game": "Join Live Game",
  "live_game_medals": "Medalhas de jogo ao vivo",
  "live_game_medals_description": "Desbloqueie medalhas ficando em 1.°, 2.° ou 3.° lugar durante um jogo ao vivo",
  "classroom_has_no_live_game": "Classroom currently has no live game",
  "speech_recognition_error_info_no_phrase": "We did not recognise your phrase. We recommend that you reword the phrase and/or add an alternative version.",
  "no_conversation_available": "Nenhuma conversa disponível",
  "enrolment_key_min_chars": "Enrolment key must be at least 5 characters long",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "game_created": "Game created",
  "play_live": "Play Live",
  "play_live_desc": "Select the exercise you'd like to play live in the classroom.",
  "live_dialog_description": "Select the exercise you'd like to play live in the classroom.",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "nuala_performance_rating": "Avaliação de Desempenho Nuala",
  "using_nuala_performance": "Se você usar a Avaliação de Desempenho Nuala, perderá qualquer avaliação criada manualmente.",
  "are_you_sure_nuala_performance": "Tem certeza de que deseja usar a Avaliação de Desempenho Nuala?",
  "course_deletion_note": "*Note deleting this course will also delete the {{sectionCount}} section(s) in this course and its contents",
  "classroom_deletion_note": "*Note deleting this classroom will also delete the {{courseCount}} course(s) in this classroom and its contents",
  "topic_deletion_note": "*Note deleting this topic will also delete the {{phraseCount}} phrase(s), {{botCount}} chatbot(s) and {{roleplayCount}} roleplay(s) in this topic and its contents",
  "section_deletion_note": "*Note deleting this section will also delete the {{topicCount}} topic(s) in this section and its contents",
  "confirmDeletionText": "To confirm deletion, type 'delete' into the field below",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "play_game": "Play Game",
  "close_game": "Close Game",
  "cancel_game": "Cancel Game",
  "end_game": "End Game",
  "games": "Games",
  "course_no_sections": "This course has no sections",
  "topic_no_phrases": "This topic has no phrases",
  "next_question": "Next question",
  "your_answer": "Your answer",
  "change_answer": "Change answer",
  "final_results": "Results",
  "game_ended": "Game ended",
  "joined_game": "Joined game",
  "equipment_problem_label": "Equipment problem",
  "equipment_problem_example": "e.g. My speaker or microphone is not working",
  "technical_problem_label": "Technical problem",
  "technical_problem_example": "e.g. The app is not working correctly",
  "content_problem_label": "Content problem",
  "content_problem_example": "e.g. I noticed a mistake in the exercise content",
  "end_question_early": "End Question Early",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "go_back_to_classroom": "Go back to Classroom",
  "discussion_created": "Discussão Criada",
  "discussion_updated": "Discussão atualizada",
  "give_feedback": "Dar Feedback",
  "nualang_live_welcome": "Welcome to Nualang Live!",
  "nualang_live_invite": "Invite Students",
  "nualang_live_invite_desc": "Click here to see how students join the game.",
  "nualang_live_game_members": "Game Members",
  "nualang_live_game_members_desc": "Click here to see who hasn't joined the game yet.",
  "nualang_live_start_game": "Start the game!",
  "nualang_live_settings": "Game Settings",
  "nualang_live_settings_desc": "Click here to see game options",
  "timer_length": "Timer Length",
  "keyboard_and_word_bank": "Keyboard and Word Bank",
  "keyboard_only": "Keyboard Only",
  "word_bank_only": "Word Bank Only",
  "answer_options": "Answer Options",
  "game_settings": "Game Settings",
  "create_feedback": "Create Feedback",
  "first_place": "First Place",
  "second_place": "Second Place",
  "third_place": "Third Place",
  "final_score": "Final Score",
  "no_discussions_found": "Nenhuma discussão encontrada",
  "no_discussions_found_desc": "Todas as discussões e envios podem ser encontrados aqui",
  "quality_of_interaction": "Qualidade da Interação",
  "number_of_questions": "Number of Questions",
  "estimated_game_time": "Estimated Game Time",
  "minutes": "Minutes",
  "discuss": "Discutir",
  "open_live_game": "Open Live Game",
  "correct_answers": "Correct Answers",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "allow_wordBank": "Allow students to use the word bank in exercises",
  "creator_default": "Creator's default",
  "course_default": "Course default",
  "course_settings_description": "Adjust the learning experience for students of this classroom",
  "change_settings": "Change Settings",
  "choose_topic_from_pdf_for_roleplay": "Choose a topic for the roleplay based on context from the course pdf",
  "use_context_from_course_pdf": "Use context from course pdf",
  "use_context_from_course_pdf_info": "Turn this on to be able to generate a roleplay based on the contents of the course pdf if the  prompt is relevent to the contents in the pdf",
  "feedback_all_info": "Fornece feedback a todos os membros do grupo de discussão. Você não pode fornecer feedback de grupo e individual a um aluno ao mesmo tempo.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "rubric_info": "Informações sobre a rúbrica",
  "listen_to_story": "Listen to the Story",
  "roleplay_no_interactions": "This roleplay has no interactions",
  "number_of_interactions": "Number of Interactions",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Modelos de Discussão",
  "discussion_templates_desc": "Use um dos nossos modelos de discussão predefinidos, aqui para ajudá-lo a criar conteúdo para seus alunos",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "empty_live_dialog_description": "Add a course if you'd like to play live in the classroom.",
  "no_classroom_to_join": "Your teacher has not setup their classroom on Nualang yet. Please ask them to do so, then try again.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_welcome": "Guia de Discussão",
  "discuss_scheduled_discussions": "Discussões Agendadas",
  "discuss_scheduled_discussions_desc": "Aqui é onde você encontrará discussões agendadas criadas pelo professor. Você poderá participar dessas discussões e conversar sobre um tópico com outros alunos do seu grupo.",
  "discuss_refresh_discussions": "Atualizar Discussões",
  "discuss_refresh_discussions_desc": "Este botão permitirá que você atualize para obter as últimas discussões agendadas.",
  "discuss_recorded_discussions": "Gravar Discussões",
  "discuss_recorded_discussions_desc": "Aqui você pode encontrar as discussões que gravou e enviou para o professor revisar. Uma vez que os feedbacks sejam dados, você poderá visualizá-los.",
  "discuss_grouped_discussions": "Discussões Agrupadas",
  "discuss_grouped_discussions_desc": "Aqui você pode encontrar todas as discussões que criou para seus alunos com base no nome do tópico. Clique em uma discussão agrupada para ver quais grupos de alunos foram criados.",
  "discuss_submissions": "Submissões de Discussão",
  "discuss_submissions_desc": "Aqui você pode encontrar as submissões de discussão gravadas criadas por grupos de alunos. Você pode ver a gravação deles, bem como a transcrição das discussões e dar feedback individual ou em grupo.",
  "refresh_discuss": "Atualizar Discussão",
  "nuala_ai": "Nuala AI",
  "performance_ratings": "Avaliações de desempenho",
  "attended": "Presente",
  "did_not_attend": "Não compareceu",
  "discussion_attendance": "Presença nas discussões",
  "submitted_recordings": "Gravações enviadas",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "add_alternative_version_explanation": "Adicione uma versão alternativa da frase a ser marcada como correta, por exemplo, 'You are welcome' pode ser uma alternativa para 'You're welcome'",
  "upload_video": "Carregar Vídeo",
  "select_video_desc": "Arraste e solte um vídeo do seu computador",
  "add_video": "Adicionar Vídeo",
  "video_info": "Vídeo do Curso",
  "play_video": "Reproduzir Vídeo",
  "delete_video": "Excluir Vídeo",
  "delete_video_confirmation": "Tem certeza de que deseja excluir este vídeo?",
  "view_video": "Ver Vídeo",
  "video_options": "Opções de Vídeo",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "pdf_options": "PDF Options",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "view_story": "View Story",
  "view_question": "View Question",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Roleplay",
  "duplicate_roleplay": "Duplicate Roleplay",
  "leave_game": "Leave Game",
  "leave_game_confirmation": "Are you sure you want to leave this game?",
  "leave": "Leave",
  "explore": "Explore",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "nualang_live_help": "How to play",
  "nualang_live_help_desc": "Click here to see how to play the game",
  "roleplay-story": "Story",
  "teach_classrooms_desc": "Manage and interact with your students in a dynamic learning environment",
  "teach_classrooms_title": "Engage Your Classroom",
  "teach_courses_desc": "Design and structure your curriculum to provide a complete learning experience",
  "teach_courses_title": "Build comprehensive courses",
  "teach_roleplays_title": "A new kind of Roleplay",
  "teach_roleplays_desc": "Teaching with roleplays allows your students to participate in scripted conversations, providing a dynamic and immersive way to practice their language skills",
  "teach_bots_title": "Creativity with chatbots",
  "teach_bots_desc": "Teaching with chatbots can help your students develop confidence and a natural conversational style that flows seamlessly, similar to real-life conversations",
  "learn_bots_title": "Creativity With Chatbots",
  "learn_bots_desc": "Learning with chatbots can help you develop a natural and engaging conversational style that flows seamlessly, just like a real conversation",
  "learn_roleplays_title": "A new kind of Roleplay",
  "learn_roleplays_desc": "Learning with roleplays allows you to participate in scripted conversations, providing a dynamic and immersive way to practice language skills",
  "learn_classrooms_desc": "Join classrooms where you can interact with your peers and teachers in a dynamic learning environment",
  "learn_classrooms_title": "Interactive Learning Spaces",
  "learn_courses_desc": "Enroll in courses designed to give you a complete learning experience with structured lessons and activities",
  "learn_courses_title": "Comprehensive learning paths",
  "video_included": "Video",
  "story_included": "Story",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "remove_question": "Remover pergunta",
  "supported_file_types": "Supported file types: mp4, mov",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "topic_no_roleplays": "This topic has no roleplays.",
  "case_sensitive": "This was marked for case sensitivity",
  "required_field": "Fields marked with * are required",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "close_drawer": "Close Drawer",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "discuss_description": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "enable_discuss": "Enable Discuss in Settings",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "incomplete_translation": "There is still more to this sentence!",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the roleplay.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the roleplay.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "enter_phrase_with_alternatives": "Enter a phrase with alternatives",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "archive_classroom": "Archive Classroom",
  "archive_classroom_confirmation": "Are you sure you want to archive this classroom?",
  "unarchive_classroom": "Unarchive Classroom",
  "unarchive_classroom_confirmation": "Are you sure you want to unarchive this classroom?",
  "confirmArchiveText": "To confirm archiving, type 'archive' into the field below",
  "confirmUnarchiveText": "To confirm unarchiving, type 'unarchive' into the field below",
  "generate_bot": "Generate Chatbot",
  "generating_bot": "Generating Chatbot",
  "choose_topic_for_bot": "What would you like this chatbot to be about?",
  "use_context_from_topic_phrases": "Use topic phrases",
  "generate_bot_existing_script_confirmation": "Are you sure you want to replace the existing script?",
  "voice_speed": "Voice Speed",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "topic_goal": "Communicative goal",
  "topic_goal_info_text": "What do you want the learner to be able to do at the end of this lesson?",
  "archived_classrooms_title": "No Archived Classrooms",
  "archived_classrooms_desc": "When you're finished with a classroom, you can archive it. This will archive the classroom for all students and collaborators.",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "ukrainian": "Ucraniano",
  "arabic": "Arabic",
  "chinese_simplified": "Chinese Simplified",
  "chinese_traditional": "Chinese Traditional",
  "czech": "Czech",
  "danish": "Danish",
  "dutch": "Dutch",
  "filipino": "Filipino",
  "greek": "Greek",
  "hindi": "Hindi",
  "hungarian": "Hungarian",
  "indonesian": "Indonesian",
  "japanese": "Japanese",
  "korean": "Korean",
  "malay": "Malay",
  "polish": "Polish",
  "punjabi": "Punjabi",
  "romanian": "Romanian",
  "swahili": "Swahili",
  "thai": "Thai",
  "turkish": "Turkish",
  "vietnamese": "Vietnamese",
  "speak_disabled": "Speak disabled",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "topic_goal_placeholder": "e.g I can ask and answer questions about my identity.",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "left_group": "Left Group",
  "view_feedback": "View Feedback",
  "no_feedback": "You have not given this student feedback yet",
  "app_search_placeholder": "Search community content",
  "delete_phrases": "Delete Phrases",
  "delete_phrases_confirmation": "Are you sure you want to delete the chosen phrases?",
  "share_audio": "Please uncheck this box if you do not want to share your audio with Nualang. Sharing the audio will help us diagnose the issue.",
  "edit_phrase": "Edit phrase",
  "share_screenshot": "Please check this box if you would like to share your screenshot with Nualang. Sharing the screenshot will help us diagnose the issue.",
  "screenshot_captured": "Screenshot captured:",
  "classroom_creator_play_live_game": "Play Nualang LIVE",
  "classroom_creator_play_live_game_desc": "Nualang LIVE offers customisable games that create a dynamic and engaging environment for students, allowing them to test their skills and compete against each other to win coveted Nuala medals.",
  "content_tags": "Add Tags",
  "enter_info_tags": "Enter a comma separated list of tags below.",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators can manage courses, students, and classroom settings.",
  "enter_domains_info": "Enter a comma or space separated list of school domains below.",
  "search_error": "Ocorreu um erro durante a pesquisa, tente novamente",
  "create_feedback_error": "Ocorreu um erro ao criar o feedback, tente novamente",
  "get_recs_error": "Ocorreu um erro ao obter as gravações",
  "get_image_error": "Ocorreu um erro ao obter as imagens",
  "update_discussion_error": "Ocorreu um erro ao atualizar a discussão, tente novamente",
  "invite_users_error": "Ocorreu um erro ao convidar usuários, tente novamente",
  "create_image_error": "Ocorreu um erro ao carregar a imagem, tente novamente",
  "grade_conversation_error": "Ocorreu um erro ao avaliar a conversa, tente novamente",
  "get_transcript_error": "Ocorreu um erro ao obter a transcrição, tente novamente",
  "get_subs_error": "Ocorreu um erro ao obter as submissões, tente novamente",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "schedule_discussion_error": "Ocorreu um erro ao agendar a discussão, tente novamente",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "freely_changed": "This can be freely changed at any time.",
  "mark_as_challenge_student": "Enable Challenge Mode",
  "unmark_as_challenge_student": "Disable Challenge Mode",
  "mark_as_challenge_bot": "Mark as Challenge Mode",
  "unmark_as_challenge_bot": "Unmark as Challenge Mode",
  "challenge_student": "Challenge Mode",
  "challenge_student_desc": "Unlocks chatbots that prompt extended responses and formal, academic language. Designed with heritage learners in mind.",
  "challenge_bot": "Challenge Mode",
  "challenge_bot_desc": "This chatbot is visible only to students with Challenge Mode enabled in the Students tab. Designed with heritage learners in mind, it provides formal, academic prompts.",
  "rewatch_tutorial": "Rewatch Tutorial",
  "heritage_speaker_progress": "Students marked as 'Read/Write' will have their learning experience adjusted to focus more on reading and writing.",
  "generate_transcript": "Generate Transcript",
  "suggested_images": "Suggested Images",
  "auto_generate_phrase_translation": "Generate Translations",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "assign_discuss": "Assign Discuss",
  "assign_discuss_desc": "Discuss is your platform for live, interactive conversations. Create engaging discussions based on your prompts or choose from suggested topics. Watch as your students collaborate and share ideas in real-time.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "O aluno editou manualmente esta transcrição após a gravação.",
  "member_updated": "Student updated",
  "delete_assignment": "Delete Assignment",
  "delete_assignment_confirmation": "Are you sure you want to delete this assignment?",
  "assignment_deleted": "Assignment deleted",
  "assignment_created": "Assignment created",
  "assignees_created": "Assignees created",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "report_type": "Type",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "not_assigned": "Not Assigned",
  "assigned": "Assigned",
  "view_assignment": "View Assignment",
  "no_assignments_description": "There are currenly no assignments created.",
  "no_shared_courses": "Não há cursos compartilhados entre as salas de aula selecionadas.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "generated_phrases": "Are you sure you want to add the following generated phrases to the list? These phrases will be appended and will not replace any existing phrases.",
  "everyone": "Everyone",
  "discussions": "Discussions",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_from_students": "Hide from Students",
  "show_to_students": "Show to Students",
  "hello": "Olá",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "ai_chatbot_message_info": "This chatbot message is generated using AI.",
  "ai_chatbot_message_generating_info": "This chatbot message is being generated using AI.",
  "language_correction": "Correção linguística",
  "correction_original": "Original",
  "correction_suggested": "Sugestão",
  "language_corrections_to_review": "Correções linguísticas para rever",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "paste_your_csv_data": "Paste your CSV data here",
  "user_level_settings": "Configurações de nível de usuário",
  "chatbot_dynamic_responses": "Chatbot - Respostas dinâmicas",
  "chatbot_dynamic_responses_desc": "Se a resposta dinâmica estiver ativada, o Chatbot ouvirá e se adaptará ativamente, pedindo mais detalhes, uma formulação mais clara ou respostas realistas, em vez de apenas passar para o próximo prompt predefinido.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? How the new Chatbot works",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Turn off all AI in this classroom. Chatbots will use their scripted replies, and AI feedback on Discuss recordings will be unavailable.",
  "limit_ai_info": "Limiting AI turns off every AI feature in this classroom at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot dynamic responses",
  "chatbot_ai_desc": "Chatbots use AI to reply to what students say. When off, they use the scripted replies they were built with.",
  "discuss_ai": "Discuss AI feedback",
  "discuss_ai_desc": "AI-generated feedback on Discuss recordings. When limited, teachers can still write their own feedback.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is limited for this classroom. Chatbots will use their original scripted replies, and AI feedback is unavailable for Discuss recordings.",
  "ai_locked_notice": "AI is limited for your whole organisation, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organisation, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Chatbot dynamic responses are allowed for this classroom, but limited for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "ai_settings": "AI Settings",
  "student_sent_inappropriate_messages": "A transcrição abaixo requer a sua revisão.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "Um aluno age de forma inadequada durante um exercício com o Chatbot",
  "ai_chatbot_error_response": "Desculpe, cometi um erro na minha resposta. Tente novamente!",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "generate_feedback_for_all": "Generate Feedback for All",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "this_classroom_is_archived": "This classroom is archived",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "submit_feedback_confirmation": "Have you reviewed all generated feedback and are you ready to submit it to students?",
  "submit_feedback_scroll": "Review all feedback before submitting it to students",
  "ai_draft_not_edited": "AI draft, not edited",
  "edited_by_you": "Edited by you",
  "approved": "Approved",
  "approve": "Approve",
  "undo": "Undo",
  "x_of_n": "{{x}} of {{n}}",
  "ai_drafts_reviewed": "AI drafts reviewed",
  "approve_ai_drafts_to_submit_one": "Approve {{count}} AI draft to submit",
  "approve_ai_drafts_to_submit_other": "Approve {{count}} AI drafts to submit",
  "ai_suggested": "AI-suggested",
  "ai_suggested_tooltip": "Your teacher used AI to draft this feedback and sent it to you.",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "generating_feedback": "Generating Feedback",
  "conversations_graded_success": "Feedback Generated",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "you_are_human": "Se você for humano, deixe este campo em branco",
  "progress": "Progress",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "meaning-listen-and-speak": "Significado - Ouvir e Falar",
  "meaning_listen_and_speak_exercise_desc": "Ouça a definição e fale a frase correta.",
  "meaning-read-and-write": "Significado - Ler e Escrever",
  "select_the_correct_phrase": "Selecione a frase correta para esta definição",
  "chinese": "Chinês",
  "custom_feedback_placeholder": "Opcional: adicione instruções extras para direcionar o feedback (por ex., precisão, complexidade ou uso das estruturas-alvo).",
  "generate_feedback_view_the": "Ver a",
  "generate_feedback_rubric_name": "Rubrica de Crescimento Analítico",
  "generate_feedback_rubric_desc": "os critérios utilizados no nosso feedback de IA.",
  "late_submission": "Envio Atrasado",
  "days_late_one": "{{count}} dia de atraso",
  "days_late_other": "{{count}} dias de atraso",
  "phrase_definition": "Definição da frase",
  "phrase_definition_helper_text": "Pressione a tecla Enter / Return para adicionar a definição.",
  "generate_definitions": "Gerar definições",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Listas de frases",
  "no_phrase_lists": "Sem listas de frases",
  "all_phrase_lists": "Todas as listas de frases",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "Ocorreu um problema ao gerar as definições. Tente novamente.",
  "saving_defintions_error": "Ocorreu um problema ao salvar as definições. Tente novamente.",
  "auto_generate_definitions": "Gerar Definições",
  "generating_definitions": "Gerando definições",
  "definitions": "Definições",
  "view_phrase_list": "Ver lista de frases",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "play_phrase_list": "Play Phrase List",
  "transfer_phrases": "Copiar para",
  "transfer": "Copiar",
  "create_phrase_list_from_selection": "Criar nova lista de frases",
  "no_other_phrase_lists": "Não há outras listas de frases",
  "add_row": "Adicionar linha",
  "problem_updating": "Houve um problema ao atualizar",
  "exercise_settings": "Configurações de exercícios",
  "excercise_voice": "Voz do exercício",
  "excercise_voice_desc": "Selecione a voz que será usada nos exercícios desta lista de frases.",
  "excercise_visibility": "Visibilidade dos exercícios",
  "keyboard": "Teclado",
  "legacy_voice_tooltip_text": "Older voice technology. May sound less natural.",
  "listen_and_speak_exercise_desc": "Listen to the definition. Say the phrase.",
  "identify_this_phrase": "Identify this phrase",
  "play_phrase": "Play Phrase",
  "listen_and_speak_exercise_welcome": "Getting started with the Listen & Speak Exercise",
  "listen_and_speak_exercise_speak_desc": "Click to listen to how the definition",
  "listen_and_speak_exercise_listen": "Listen to the definition!",
  "listen_and_speak_exercise_voice_input": "Pronounce the phrase that matches the definition",
  "hide_phrase_image": "Hide phrase image",
  "show_phrase_image": "Show phrase image",
  "read_write_exercise_welcome": "Bem-vindo ao Exercício de Ler e Escrever",
  "read_write_exercise_definition": "Definição",
  "read_write_exercise_definition_desc": "Leia a definição mostrada aqui",
  "read_write_exercise_options": "Digite a Frase",
  "read_write_exercise_options_desc": "Digite a frase correta na caixa de texto",
  "read_the_definition": "Leia a definição",
  "type_the_correct_phrase": "Digite a frase correta",
  "read_write": "Ler e Escrever",
  "meaning_read_write": "Significado - Ler e Escrever",
  "meaning_read_write_exercise_desc": "Leia a definição e digite a frase correta.",
  "course_description_default": "This is a course to help students speak {{learnLang}} with confidence.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "create_chatbot": "Criar chatbot",
  "find_chatbot": "Encontrar chatbot",
  "find_chatbots": "Encontrar chatbots",
  "add_chatbot": "Adicionar chatbot",
  "add_chatbots": "Adicionar chatbots",
  "template": "Modelo",
  "chatbot_name": "Nome do chatbot",
  "create_scenario": "Criar roleplay",
  "find_scenario": "Encontrar roleplay",
  "find_scenarios": "Encontrar roleplays",
  "scenario_name": "Nome do roleplay",
  "scenarios_added": "Roleplays adicionados ao tópico",
  "chatbots_added": "Chatbots adicionados ao tópico",
  "add_scenarios": "Adicionar roleplays",
  "achievements": "Conquistas",
  "topic_description_default": "This is a topic to help students speak {{learnLang}} with confidence.",
  "selected_topics": "Selected Topics",
  "no_topics_selected": "No topics selected",
  "add_topics": "Add topics",
  "find_topics": "Find topics",
  "find_topic": "Find Topic",
  "no_topics_found": "No topics found",
  "no_library_topics_community_hint": "Encontre tópicos criados por outros professores na aba <1>Comunidade</1>.",
  "chatbot_title": "Título do Chatbot",
  "open_ended": "De resposta aberta",
  "open_ended_desc": "Deixe seus alunos responderem com suas próprias palavras.",
  "quiz": "Quiz",
  "quiz_desc": "Orientação ao aluno através de uma série de perguntas.",
  "picture_quiz": "Teste de imagem",
  "picture_quiz_desc": "Faça perguntas com base nas imagens.",
  "emoji_quiz": "Emoji Quiz",
  "emoji_quiz_desc": "Adivinhe a resposta com base nos emojis.",
  "quiz_style_templates": "Modelos no estilo de quiz",
  "no_scenarios_found": "Nenhum roleplay encontrado",
  "no_chatbots_found": "Nenhum chatbot encontrado",
  "use_voice": "Usar voz",
  "internal_view_provider_marks": "Vista interna · Notas do fornecedor visíveis",
  "legacy": "Antigo",
  "scan_to_open_the_classroom": "Digitalize para abrir a sala de aula",
  "classroom_link": "Ligação da sala de aula",
  "copy": "Copiar",
  "tell_students_to": "Diga aos alunos para",
  "invite_step_sign_in": "Iniciar sessão na sua conta.",
  "invite_step_scan": "Digitalizar o código ou abrir a sala de aula.",
  "invite_step_tap_join": "Tocar em {{button}}.",
  "select_exercise_phrases_intro": "Selecione as listas de frases que quer jogar. Pode misturar listas de cursos diferentes.",
  "select_exercise_scenarios_intro": "Escolha um cenário para jogar ao vivo com a turma.",
  "source_type_phrase_lists": "Listas de frases",
  "source_type_scenarios": "Cenários",
  "clear_all": "Limpar tudo",
  "n_of_m_lists_selected": "{{n}} de {{m}} listas selecionadas",
  "n_phrase_lists": "{{count}} listas de frases",
  "n_phrases": "{{count}} frases",
  "has_definitions": "tem definições",
  "n_scenarios": "{{count}} cenários",
  "n_messages": "{{count}} mensagens",
  "n_interactions": "{{count}} interações",
  "lists_and_phrases_selected": "{{lists}} listas · {{phrases}} frases",
  "no_lists_selected": "Nenhuma lista selecionada",
  "no_scenario_selected": "Nenhum cenário selecionado",
  "scenario_selected": "Cenário selecionado",
  "number_of_messages": "Número de mensagens",
  "max_phrases_label": "Máx.",
  "max_phrases_all": "Todas as {{count}}",
  "estimated_game_time_hint": "{{questions}} perguntas a {{seconds}}s cada, mais o feedback entre rondas.",
  "n_minutes": "{{count}} minutos",
  "live_game_title": "{{exercise}} · {{count}} listas de frases",
  "phrases_from": "Frases de",
  "source_card_meta": "{{topic}} · {{count}} frases",
  "n_more": "mais",
  "waiting_for_students": "À espera que os alunos entrem.",
  "how_students_answer": "Como os alunos respondem",
  "answer_keyboard_and_word_bank": "Teclado e banco de palavras",
  "answer_keyboard_and_word_bank_hint": "Os alunos escrevem, com peças de palavras como alternativa.",
  "answer_keyboard_only": "Apenas teclado",
  "answer_keyboard_only_hint": "Mais difícil — os alunos escrevem a resposta completa.",
  "answer_word_bank_only": "Apenas banco de palavras",
  "answer_word_bank_only_hint": "Mais fácil — os alunos tocam nas palavras para as colocar.",
  "time_per_question": "Tempo por pergunta",
  "all_n_phrases": "Todas as {{count}} frases",
  "includes_one_from_each_list": "É sempre incluída pelo menos uma frase de cada lista selecionada.",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario",
  "all_languages": "Todos os idiomas",
  "all_levels": "Todos os níveis",
  "novice": "Iniciante",
  "intermediate": "Intermediário",
  "advanced": "Avançado",
  "popular": "Popular",
  "courses_shared_by_other_teachers": "Cursos compartilhados por outros professores",
  "no_created_courses_match": "Nenhum curso criado corresponde a esses filtros",
  "no_joined_courses_match": "Nenhum curso ingressado corresponde a esses filtros",
  "no_community_courses_match": "Nenhum curso corresponde a esses filtros",
  "courses_added": "Cursos adicionados",
  "problem_adding_courses": "Havia um problema ao adicionar esses cursos",
  "search_topics_placeholder": "Pesquisar tópicos",
  "search_classrooms_placeholder": "Pesquisar salas de aula",
  "search_student_name": "Pesquisar nome do aluno",
  "search_sections_and_topics": "Pesquisar secções e tópicos",
  "clear_search": "Limpar pesquisa",
  "x_of_y": "{{shown}} de {{total}}",
  "outline_filter_count": "{{topics}} em {{sections}}",
  "topic_count_one": "{{count}} tópico",
  "topic_count_other": "{{count}} tópicos",
  "section_count_one": "{{count}} secção",
  "section_count_other": "{{count}} secções",
  "no_sections_or_topics_match": "Nenhuma secção ou tópico corresponde",
  "try_different_keyword_or_difficulty": "Experimente outra palavra-chave ou outra dificuldade.",
  "nothing_matches_keyword_at_difficulty": "Nada corresponde a “{{keyword}}” com dificuldade {{difficulty}}. Experimente outra palavra-chave ou outra dificuldade.",
  "session_feedback": "O teu feedback",
  "session_feedback_preparing": "A preparar o teu feedback…",
  "session_feedback_unavailable": "O teu feedback não está disponível de momento.",
  "suggested_level": "Nível sugerido",
  "session_report": "Feedback da conversa",
  "view_full_report": "Ver feedback completo",
  "rating_approaching": "Em progresso",
  "rating_meets": "Atinge",
  "rating_exceeds": "Supera",
  "area_of_strength": "Ponto forte",
  "area_for_growth": "Área a melhorar",
  "rating_not_yet": "Ainda não",
  "session_report_short_interaction": "Interação",
  "session_report_short_vocabulary": "Vocabulário",
  "session_report_short_function": "Função",
  "session_report_strength": "Ponto forte",
  "session_report_growth": "Melhoria",
  "ai_generated_report": "Feedback gerado por IA",
  "ai_generated_report_tooltip": "Gerado por IA apenas a partir desta sessão. O nível sugerido e as avaliações são estimativas, não uma colocação definitiva.",
  "session_report_new": "Novo",
  "chatbot_mode_name": "Chatbot - {{mode}}",
  "chatbot_message_count": "{{count}} mensagens",
  "chatbot_message_count_one": "{{count}} mensagem",
  "chatbot_message_count_other": "{{count}} mensagens",
  "attempt_count": "{{count}} tentativas",
  "attempt_count_one": "{{count}} tentativa",
  "attempt_count_other": "{{count}} tentativas",
  "of_total_correct": "de {{total}} corretas",
  "attempts_to_review": "Tentativas para rever",
  "attempts_not_shown": "{{items, list}}: tentativas não mostradas",
  "count_correct": "{{count}} corretas",
  "count_incorrect": "{{count}} incorretas",
  "count_skipped": "{{count}} ignoradas",
  "count_partially_correct": "{{count}} parcialmente corretas",
  "view_all_count": "Ver todas as {{count}}",
  "view_attempt": "Ver tentativa",
  "scenario_description_default": "Este é um cenário para ajudar os alunos a falar {{learnLang}} com confiança."
}
